import { BffApiClient } from '@cvo/domain/api/clients/BffApiClient';
import { BffAuthenticatedApiClient } from '@cvo/domain/api/clients/BffAuthenticatedApiClient';
import * as repositories from '@cvo/domain/api/repositories';
import type { Repositories } from '@cvo/domain/api/repositories/Repositories';

export default defineNuxtPlugin((_nuxtApp) => {
  const config = useRuntimeConfig();

  BffApiClient.initialize({
    baseUrl: config.public.bffGatewayBaseUrl as string,
    tenantId: config.public.tenantId as string | undefined,
  });

  BffAuthenticatedApiClient.initialize({
    baseUrl: config.public.bffGatewayBaseUrl as string,
    tenantId: config.public.tenantId as string | undefined,
  });

  const api: Repositories = Object.values(repositories).reduce((prev, RepoClass) => {
    // @ts-expect-error It's hard to iterate over a dynamic list and bind the keys to the correct Repository class.
    prev[RepoClass.name] = new RepoClass();
    return prev;
  }, {} as Repositories);

  return {
    provide: {
      api,
    },
  };
});

declare module '#app' {
  interface NuxtApp {
    $api: Repositories;
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $api: Repositories;
  }
}
